import { HrefLink as Link } from "@/components/ui/href-link";

import { app, notFound } from "@/content";
import { useLocale } from "@/context/locale-provider";

/**
 * A real 404.
 *
 * The prototype redirected any unknown URL to `/`, which then bounced again by
 * role — so a mistyped address or a stale deep link gave no feedback at all, and
 * looked identical to being signed out.
 *
 * Reachable from either side of the session boundary, so it carries its own
 * chrome rather than assuming the console shell is above it.
 */
export function NotFoundPage() {
  const { locale } = useLocale();

  return (
    <div className="on-navy flex min-h-svh flex-col items-center justify-center bg-navy-900 px-6 text-center">
      {/* The ghost numeral, the one place in the console it appears. */}
      <p aria-hidden className="text-5xl font-black text-white/[0.06] tabular">
        {locale === "en" ? "404" : "٤٠٤"}
      </p>

      <h1 className="-mt-6 text-lg font-bold text-on-navy">{notFound.title}</h1>
      <p className="mt-3 max-w-[42ch] text-sm leading-body text-on-navy-dim">
        {notFound.lead}
      </p>

      <Link
        to="/dashboard"
        className="btn-primary mt-7 inline-flex h-11 items-center rounded-lg px-5 text-sm font-bold transition-transform duration-300 ease-brand"
      >
        {notFound.backToConsole}
      </Link>

      <p className="mt-10 text-[11px] font-semibold tracking-[0.04em] text-on-navy-dim">
        {app.nameFull}
      </p>
    </div>
  );
}
